//Browser list
//Google Chrome, Firefox, Opera, IE, Microsoft Edge, Safari
function getNavigatorInfo() {
    // @ts-ignore
    if (navigator.userAgentData && navigator.userAgentData.brands) {
        // @ts-ignore
        const mainBrand = navigator.userAgentData.brands[0];
        return {brand:mainBrand.brand,version:mainBrand.version};
    }
    else {
        return {brand: getNavigatorName(), version: getNavigatorVersion()}
    }
}

function getNavigatorVersion() {
    const spec_string = navigator.userAgent;

    let matches = spec_string.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    // Work with the matches.
    matches = matches[2] ? [matches[1], matches[2]] : [navigator.appName, navigator.appVersion, '-?'];

    let temp;
    let version;
    // Trident.
    if (/trident/i.test(matches[1])) {
        temp = /\brv[ :]+(\d+)/g.exec(spec_string) || [];
        version = (temp[1] || '');
        return version;
    }

    // Chrome.
    if (matches[1] === 'Chrome') {
        temp = spec_string.match(/\bOPR|Edge\/(\d+)/)
        version = temp[1];
        if (temp != null) { return version; }
    }

    if ((temp = spec_string.match(/version\/(\d+)/i)) != null) {
        matches.splice(1, 1, temp[1]);
    }

    return matches[1];
};

function getNavigatorName() {
    const spec_string = navigator.userAgent;

    let matches = spec_string.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    // Work with the matches.
    matches = matches[2] ? [matches[1], matches[2]] : [navigator.appName, navigator.appVersion, '-?'];

    let temp;
    // Trident.
    if (/trident/i.test(matches[1])) {
        temp = /\brv[ :]+(\d+)/g.exec(spec_string) || [];
        return 'IE';
    }

    // Chrome.
    if (matches[1] === 'Chrome') {
        temp = spec_string.match(/\bOPR|Edge\/(\d+)/)
        if (temp != null) { return 'Opera'; }
    }

    if ((temp = spec_string.match(/version\/(\d+)/i)) != null) {
        matches.splice(1, 1, temp[1]);
    }

    const brand = matches[0].charAt(0).toUpperCase() + matches[0].slice(1);
    if (brand == "Chrome") return "Google Chrome";
    else if (brand == "Edge") return "Microsoft Edge";
    else return brand;
};